import { makeAutoObservable } from 'mobx'
import { type IDropdownItem } from 'shared/ui'

export class UsersMultiDropdownStore {
  constructor(public initUsersIds?: number[]) {
    makeAutoObservable(this)
  }

  get params() {
    if (this.initUsersIds) {
      return this.initUsersIds
    } else {
      return this.selectedMembersIds
    }
  }

  private _selectedMembers: IDropdownItem[] = []
  get selectedMembers() {
    return this._selectedMembers
  }
  setSelectedMembers = (value: IDropdownItem) => {
    if (this.initUsersIds) {
      this.initUsersIds = undefined
    }
    this._selectedMembers = [...this._selectedMembers, value]
  }
  setInitMembers = (items: IDropdownItem[]) => {
    this._selectedMembers = items
    this.initUsersIds = undefined
  }

  get selectedMembersIds() {
    return this.selectedMembers.map((elem) => Number(elem.id))
  }

  deleteSelectedMembers = (value: IDropdownItem) => {
    this._selectedMembers = this._selectedMembers.filter((item) => item.id !== value.id)
  }

  private _error = ''
  get error() {
    return this._error
  }
  setError = (error: string) => {
    this._error = error
  }

  validate = () => {
    let valid = true
    this.setError('')
    if (!this.selectedMembers.length) {
      this.setError('Please select at least one user')
      valid = false
    }
    return valid
  }
}
